import { Component, OnInit } from '@angular/core';
import { ApiGatewayService, AppContextService, EcaSecurityService, WindowService } from '@drc-eca/eca-components-lib';
import { Router, ActivatedRoute } from '@angular/router';
import { PortalService } from '../portal.service';
import { take } from 'rxjs/operators';
import { LoginMessageService } from '../services/login-message.service';

@Component({
  selector: 'app-saml-login',
  templateUrl: './saml-login.component.html',
  styleUrls: ['./saml-login.component.scss']
})
export class SamlLoginComponent implements OnInit {

  constructor(
    private apiGatewayService: ApiGatewayService,
    private appContextService: AppContextService,
    private loginMessageService: LoginMessageService,
    private portalService: PortalService,
    private route: ActivatedRoute,
    private router: Router,
    private securityService: EcaSecurityService,
    private windowService: WindowService,
  ) { }

  async ngOnInit() {
    const {token, extras} = await this.route.params.pipe(take(1)).toPromise();

    let productCode, returnUrl;

    if (extras) {
      for (const extra of JSON.parse(extras) as string[]) {
        if (extra.startsWith('c:')) {
          productCode = extra.split('c:')[1];
        }

        if (extra.startsWith('returnUrl:')) {
          returnUrl = extra.split('returnUrl:')[1];
        }
      }
    }

    try {
      await this.securityService.authenticateToken(token).toPromise();
      this.appContextService.setToken(token);
      this.appContextService.setPortalUrl(this.portalService.getPortalUrl(location));
      this.apiGatewayService.clearCache();

      // restore product code set by product-login.component.ts
      if (productCode) {
        this.appContextService.setSelectedProductCode(productCode);
      }

      // navigate to redirect URL when one was provided
      if (returnUrl) {
        // navigate to the product selection page first when no product is specified
        if (!productCode) {
          const redirectUrlWithParams = `${this.portalService.getPortalUrl(location)}/#/products?t=${token}${productCode ? `&c=${productCode}` : ''}&returnUrl=${encodeURIComponent(decodeURIComponent(returnUrl))}`;
          this.windowService.navigateTo(redirectUrlWithParams);
          return;
        }

        // navigate directly to the returnUrl when a product is specified
        const redirectUrlWithParams = new URL(returnUrl);
        redirectUrlWithParams.searchParams.set('t', token);
        redirectUrlWithParams.searchParams.set('c', productCode);
        this.windowService.navigateTo(redirectUrlWithParams.href);
        return;
      }

      this.appContextService.getSelectedProductCode().subscribe(productCode => {
        if (productCode) {
          this.router.navigate(['/products', productCode, 'welcome']);
        } else {
          this.router.navigate(['/products']);
        }
      });

    } catch (err) {
      console.error(err);
      let message = 'An error occurred while processing your login request';
      if (err.error?.code === 'island') {
        message = err.error.message;
      }
      this.loginMessageService.setErrorMessage(message);
      this.router.navigate(['/logout']);
    }
  }

}
